import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

module.exports = {
    createFetchParams: (pagination, filters, ordering) => ({...pagination, ...filters, ordering}),
    ...storeModuleFactory({
        name:               'impersonateUser',
        endpoint:           endpoints.impersonateUser.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: item => item.results.map(user => {
            const accounts = [];

            // Object.keys(user).filter(key => key.includes('_accounts'))
            //     .forEach(key => {
            //         const vendorIcon = key.replace('_accounts', '');
            //         // if (user['vcloud_accounts'].length) {
            //         //     user[key].forEach(account => {
            //         //         accounts.push({
            //         //             vendor: vendorIcon === 'google' ? 'gcloud' : vendorIcon,
            //         //             ...account
            //         //         });
            //         //     });
            //         // }
            //     });

            return {
                id:           user.id,
                name:         `${user.first_name.trim()} ${user.last_name.trim()}`,
                email:        user.email,
                username:     user.username,
                customerName: user.customer.company_name,
                customerId:   user.customer.id,
                accounts
            };
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/impersonateUser.js